export default (props, traits) => {
  const { colors, rhythm } = traits

  return {
    root: {
      padding: rhythm([0.5, 1]),
      marginTop: rhythm(0.5),
      backgroundColor: colors.success,
      color: colors.light
    }
  }
}
